import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
	reducerPath: "api",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://lws-server-1494.herokuapp.com",
	}),
	tagTypes: ["Todos"],
	endpoints: (builder) => ({
		getTodos: builder.query({
			query: ({status = "", colors = []}) => {
				let queryString = "";
				if(status !== "") {
					queryString += `completed_like=${status}&`;
				}
				if(colors.length > 0) {
					queryString += colors.map(col => `color_like=${col}`).join("&");
				}

				return `/todos?${queryString}`
			},
			providesTags: ["Todos"]
		}),
		addTodo: builder.mutation({
			query: (data) => ({
				url: "/todos",
				method: "POST",
				body: data,
			}),
			invalidatesTags: ["Todos"]
		}),
		editTodo: builder.mutation({
			query: ({ id, data }) => ({
				url: `/todos/${id}`,
				method: "PATCH",
				body: data,
			}),
			invalidatesTags: ["Todos"]
		}),
		editTodoStatus: builder.mutation({
			query: ({ id, data }) => ({
				url: `/todos/${id}`,
				method: "PATCH",
				body: data,
			}),
			invalidatesTags: ["Todos"]
		}),
		editTodoColor: builder.mutation({
			query: ({ id, data }) => ({
				url: `/todos/${id}`,
				method: "PATCH",
				body: data,
			}),
			invalidatesTags: ["Todos"]
		}),
		deleteTodo: builder.mutation({
			query: ({ id }) => ({
				url: `/todos/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Todos"]
		}),
	}),
});

export const {
	useGetTodosQuery,
	useAddTodoMutation,
	useDeleteTodoMutation,
	useEditTodoMutation,
	useEditTodoColorMutation,
	useEditTodoStatusMutation,
} = apiSlice;
